
import i18n from '@/i18n'
// 收获地址审核状态
export const addressCheckStatus = {
  PASS_ING: 0, // 未审核
  PASS_TRUE: 1, // 审核已通过
  PASS_FALSE: 2 // 审核已驳回
}
// 匹配收获地址审核状态
export const hasAddressCheck = (status) => {
  if (status === addressCheckStatus.PASS_ING) {
    return '待审核'
  } else if (status === addressCheckStatus.PASS_TRUE) {
    return '已审核'
  } else if (status === addressCheckStatus.PASS_FALSE) {
    return '审核未通过'
  } else {
    return 'error'
  }
}

export const menuList =  [
  {
      id: 1,
      path: "createOrder",
      name: "createOrder",
      label: i18n.t('router.router1'),
  },
  {
      id: 3,
      path: "orderList",
      name: "orderList",
      label: i18n.t('store.store1'),
  },
  {
      id: 4,
      path: "arrivalOrder",
      name: "arrivalOrder",
      label: i18n.t('arrivalOrder.arrivalOrder1'),
      count: 0,
  },
  {
      id: 8,
      path: "inStorageOrder",
      name: "inStorageOrder",
      label: i18n.t('inStorageOrder.inStorageOrder1'),
      count: 0,
  },
  {
      id: 7,
      path: "badOrder",
      name: "badOrder",
      label: i18n.t('orderList.orderList12'),
      count: 0,
  },
  {
      id: 5,
      path: "buddleOrder",
      name: "buddleOrder",
      label: i18n.t('BuddleOrder.BuddleOrder19'),
  },
  {
      id: 6,
      path: "FBA",
      name: "FBA",
      label: i18n.t('store.store2'),
  },
  {
      id: 9,
      path: "funding",
      name: "funding",
      label: i18n.t('router.router5'),
  },
  {
      id: 10,
      path: "badList",
      name: "badList",
      label: i18n.t('home.home23'),
  },
  {
      id: 2,
      path: "recharge",
      name: "recharge",
      label: i18n.t('store.store3'),
  },
  {
      id: 11,
      path: "message",
      name: "message",
      label: "消息提醒",
  },
  {
      id: 12,
      path: "address",
      name: "Address",
      label: "地址管理",
  },
  {
      id: 13,
      path: "defective",
      name: "defective",
      label: "不良件详情",
  },
  {
      id: 13,
      path: "laundryLabelTemplate",
      name: "laundryLabelTemplate",
      label: "水洗标模板管理",
  },
]